<template>
  <div class="content">
    <h2 class="title text-h6 mt-4 grey--text text--darken-4">
      Política de Privacidad
    </h2>
    <h3 class="overline my-2 mb-4">
      App Mobees para Conductores
    </h3>

    <p>
      Esta aplicación es mantenida y operada por MOBEES ON WHEELS BRASIL LTDA.
    </p>
    <p>
      Recopilamos y utilizamos algunos datos personales de quienes utilizan nuestra aplicación. Al hacerlo, actuamos en calidad de responsable del tratamiento de esos datos y estamos sujetos a las disposiciones de la Ley Federal n. 13.709/2018 (Lei Geral de Proteção de Dados Pessoais - LGPD).
    </p>
    <p>
      Cuidamos la protección de sus datos personales y, por ello, ponemos a disposición esta política de privacidad, que contiene información importante sobre:
    </p>
    <ul class="mb-8">
      <li>Quién debe utilizar nuestra aplicación</li>
      <li>Qué datos recopilamos y qué hacemos con ellos</li>
      <li>Sus derechos en relación con sus datos personales</li>
      <li>Cómo contactarnos</li>
    </ul>

    <h4 class="subtitle-2">
      1. Quién debe utilizar nuestra aplicación
    </h4>
    <p>
      Nuestra aplicación solo debe ser utilizada por personas mayores de dieciocho años. Por lo tanto, niños y adolescentes no deben utilizarla.
    </p>

    <h4 class="subtitle-2">
      2. Datos que recopilamos y motivos de la recopilación
    </h4>
    <p>
      Nuestra aplicación recopila y utiliza algunos datos personales de nuestros usuarios, de acuerdo con lo dispuesto en esta sección.
    </p>
    <h4 class="subtitle-2 font-italic">
      2.1. Datos personales proporcionados expresamente por el usuario
    </h4>
    <p>
      Recopilamos los siguientes datos personales que nuestros usuarios nos proporcionan expresamente al utilizar nuestra aplicación.
    </p>
    <p class="indent">
      Datos del conductor (evaluación de perfil):
    </p>
    <ul class="mb-4">
      <li>{{ $t('profile.personal.fullname') }}</li>
      <li>{{ $t('profile.personal.social_id') }}</li>
      <li>{{ $t('profile.personal.email') }}</li>
      <li>{{ $t('profile.personal.phone') }}</li>
      <li>{{ $t('profile.personal.address.zip_code') }}</li>
      <li>{{ $t('profile.personal.address.country') }}</li>
      <li>{{ $t('profile.personal.address.state') }}</li>
      <li>{{ $t('profile.personal.address.city') }}</li>
      <li>{{ $t('profile.personal.address.neighborhood') }}</li>
      <li>{{ $t('profile.personal.address.street') }}</li>
      <li>{{ $t('profile.personal.address.number') }}</li>
      <li>{{ $t('profile.personal.address.compl') }}</li>
      <li>{{ $t('login.referral_email') }}</li>
      <li>{{ $t('profile.personal.gender.label') }}</li>
      <li>{{ $t('profile.personal.photo') }}</li>
      <li>{{ $t('profile.personal.birthdate') }}</li>
      <li>{{ $t('profile.vehicle.parking.label') }}</li>
      <li>{{ $t('profile.job.experience.label') }}</li>
      <li>{{ $t('profile.job.service_model.label') }}</li>
      <li>{{ $t('profile.job.fulltime.label') }}</li>
      <li>{{ $t('profile.job.journey.label') }}</li>
      <li>{{ $t('profile.job.region.label') }}</li>
      <li>{{ $t('profile.job.rating.label') }}</li>
      <li>{{ $t('profile.gps') }}</li>
      <li>{{ $t('profile.push') }}</li>
      <li>{{ $t('profile.vehicle.rental') }}</li>
      <li>{{ $t('profile.vehicle.brand') }}</li>
      <li>{{ $t('profile.vehicle.model.label') }}</li>
      <li>{{ $t('profile.vehicle.year') }}</li>
      <li>{{ $t('profile.vehicle.owner.label') }} ({{ $t('profile.vehicle.owner.owner') }}, {{ $t('profile.vehicle.owner.borrowed') }} u {{ $t('profile.vehicle.owner.rental') }})</li>
      <li>{{ $t('profile.vehicle.owner.relative') }}</li>
      <li>Mensajes de contacto</li>
    </ul>
    <p class="indent">
      Datos del conductor (documentación):
    </p>
    <ul>
      <li>{{ $t('profile.personal.id_number') }}</li>
      <li>Foto del {{ $t('profile.personal.id_number') }}</li>
      <li>{{ $t('profile.personal.id_issuer') }}</li>
      <li>Comprobante de domicilio</li>
      <li>{{ $t('profile.personal.drivers_license') }}</li>
      <li>Foto de la {{ $t('profile.personal.drivers_license') }}</li>
      <li>Foto del documento del vehículo</li>
      <li>{{ $t('profile.vehicle.plate') }}</li>
      <li>{{ $t('profile.vehicle.chassis') }}</li>
      <li>{{ $t('profile.vehicle.color.label') }}</li>
      <li>{{ $t('profile.vehicle.vehicle_id') }}</li>
      <li>{{ $t('profile.vehicle.owner.name') }}</li>
      <li>{{ $t('profile.vehicle.owner.email') }}</li>
      <li>{{ $t('profile.vehicle.owner.id_number') }}</li>
      <li>Foto del {{ $t('profile.vehicle.owner.id_number') }}</li>
      <li>{{ $t('profile.vehicle.owner.id_issuer') }}</li>
      <li>{{ $t('profile.vehicle.owner.social_id') }}</li>
      <li>Foto del {{ $t('profile.vehicle.owner.social_id') }}</li>
    </ul>
    <p class="indent">
      Datos del conductor (firma):
    </p>
    <ul>
      <li>Término de autorización de utilización del vehículo</li>
    </ul>
    <p class="indent">
      Datos del socio:
    </p>
    <ul>
      <li>{{ $t('profile.payment.bank') }}</li>
      <li>{{ $t('profile.payment.branch') }}</li>
      <li>{{ $t('profile.payment.account') }} {{ $t('profile.payment.account_digit') }}</li>
      <li>{{ $t('profile.payment.account_type.label') }}</li>
      <li>{{ $t('profile.payment.account_compl') }}</li>
    </ul>
    <p>
      La recopilación de estos datos ocurre en los siguientes momentos:
    </p>
    <ul>
      <li>cuando el usuario completa sus datos para evaluación de perfil</li>
      <li>cuando el usuario completa sus datos en la fase de documentación</li>
      <li>cuando el usuario firma el término de autorización de utilización del vehículo</li>
      <li>cuando el usuario es seleccionado y agendado para instalación</li>
      <li>cuando el usuario envía un correo electrónico o un mensaje por Whatsapp</li>
    </ul>
    <p>
      Los datos proporcionados por nuestros usuarios son recopilados con las siguientes finalidades:
    </p>
    <ul>
      <li>para que el usuario (conductor) participe del proceso de selección de nuevos socios</li>
      <li>para que el usuario (socio) sea atendido conforme a los Términos y Condiciones</li>
    </ul>
    <h4 class="subtitle-2 font-italic">
      2.2. Datos personales obtenidos de otras formas
    </h4>
    <p>
      Recopilamos los siguientes datos personales de nuestros usuarios:
    </p>
    <ul>
      <li>datos de geolocalización</li>
    </ul>
    <p>
      La recopilación de estos datos ocurre en los siguientes momentos:
    </p>
    <ul>
      <li>cuando el usuario habilita la opción GPS, el sistema recopila datos de geolocalización cada 5 minutos. Mobees se reserva el derecho de aumentar o disminuir esa frecuencia en función de la evaluación del desempeño de la aplicación</li>
    </ul>
    <p>
      Estos datos son recopilados con las siguientes finalidades:
    </p>
    <ul>
      <li>perfeccionar la evaluación del perfil del conductor</li>
    </ul>
    <h4 class="subtitle-2 font-italic">
      2.3. Datos sensibles
    </h4>
    <p>
      <b>No</b> se recopilarán datos sensibles de nuestros usuarios, entendiendo por tales los definidos en los arts. 11 y siguientes de la Ley de Protección de Datos Personales. Así, <b>no</b> habrá recopilación de datos sobre origen racial o étnico, convicción religiosa, opinión política, afiliación a sindicato o a organización de carácter religioso, filosófico o político, dato referente a la salud o a la vida sexual, dato genético o biométrico cuando esté vinculado a una persona natural.
    </p>
    <h4 class="subtitle-2 font-italic">
      2.4. Recopilación de datos no previstos expresamente
    </h4>
    <p>
      Eventualmente, podrán ser recopilados otros tipos de datos no previstos expresamente en esta Política de Privacidad, siempre que sean proporcionados con el consentimiento del usuario o que la recopilación esté permitida con fundamento en otra base legal prevista en la ley.
    </p>
    <p>
      En cualquier caso, la recopilación de datos y las actividades de tratamiento derivadas serán informadas a los usuarios de la aplicación.
    </p>

    <h4 class="subtitle-2">
      3. Compartir datos personales con terceros
    </h4>
    <p>
      No compartimos sus datos personales con terceros. A pesar de ello, es posible que lo hagamos para cumplir alguna determinación legal o regulatoria, o para cumplir alguna orden expedida por autoridad pública.
    </p>

    <h4 class="subtitle-2">
      4. Por cuánto tiempo se almacenarán sus datos personales
    </h4>
    <p>
      Los datos personales recopilados por la aplicación son almacenados y utilizados por un período de tiempo que corresponda a lo necesario para alcanzar las finalidades enumeradas en este documento y que considere los derechos de sus titulares, los derechos del responsable de la aplicación y las disposiciones legales o regulatorias aplicables.
    </p>
    <p>
      Una vez expirados los períodos de almacenamiento de los datos personales, estos son removidos de nuestras bases de datos o anonimizados, salvo en los casos en que exista la posibilidad o la necesidad de almacenamiento en virtud de disposición legal o regulatoria.
    </p>

    <h4 class="subtitle-2">
      5. Bases legales para el tratamiento de datos personales
    </h4>
    <p>
      Una base legal para el tratamiento de datos personales no es más que un fundamento jurídico, previsto en ley, que lo justifica. Así, cada operación de tratamiento de datos personales debe tener una base legal que le corresponda.
    </p>
    <p>
      Tratamos los datos personales de nuestros usuarios en las siguientes hipótesis:
    </p>
    <ul>
      <li>mediante el consentimiento del titular de los datos personales</li>
      <li>cuando sea necesario para atender a los intereses legítimos del responsable o de tercero</li>
    </ul>
    <h4 class="subtitle-2 font-italic">
      5.1. Consentimiento
    </h4>
    <p>
      Determinadas operaciones de tratamiento de datos personales realizadas en nuestra aplicación dependerán de la previa concordancia del usuario, que deberá manifestarla de forma libre, informada e inequívoca.
    </p>
    <p>
      El usuario podrá revocar su consentimiento en cualquier momento; no habiendo hipótesis legal que permita o exija el almacenamiento de los datos, los datos proporcionados mediante consentimiento serán excluidos.
    </p>
    <p>
      Además, si lo desea, el usuario podrá no concordar con alguna operación de tratamiento de datos personales basada en el consentimiento. En estos casos, sin embargo, es posible que no pueda utilizar alguna funcionalidad de la aplicación que dependa de aquella operación. Las consecuencias de la falta de consentimiento para una actividad específica son informadas previamente al tratamiento.
    </p>
    <h4 class="subtitle-2 font-italic">
      5.2. Interés legítimo
    </h4>
    <p>
      Para determinadas operaciones de tratamiento de datos personales, nos basamos exclusivamente en nuestro interés legítimo. Para saber más sobre en qué casos, específicamente, nos valemos de esta base legal, o para obtener más información sobre las pruebas que realizamos para tener certeza de que podemos utilizarla, contacte a nuestro Encargado de Protección de Datos Personales por alguno de los canales informados en esta Política de Privacidad, en la sección "Cómo contactarnos".
    </p>

    <h4 class="subtitle-2">
      6. Derechos del usuario
    </h4>
    <p>
      El usuario de la aplicación posee los siguientes derechos, conferidos por la Ley de Protección de Datos Personales:
    </p>
    <ul>
      <li>confirmación de la existencia de tratamiento</li>
      <li>acceso a los datos</li>
      <li>corrección de datos incompletos, inexactos o desactualizados</li>
      <li>anonimización, bloqueo o eliminación de datos innecesarios, excesivos o tratados en desconformidad con lo dispuesto en la ley</li>
      <li>portabilidad de los datos a otro proveedor de servicio o producto, mediante requisición expresa, de acuerdo con la regulación de la autoridad nacional, observados los secretos comercial e industrial</li>
      <li>eliminación de los datos personales tratados con el consentimiento del titular, salvo en los casos previstos en ley</li>
      <li>información de las entidades públicas y privadas con las que el responsable realizó uso compartido de datos</li>
      <li>información sobre la posibilidad de no proporcionar consentimiento y sobre las consecuencias de la negativa</li>
      <li>revocación del consentimiento</li>
    </ul>
    <p>
      Es importante destacar que, en los términos de la LGPD, no existe un derecho de eliminación de datos tratados con fundamento en bases legales distintas del consentimiento, a menos que los datos sean innecesarios, excesivos o tratados en desconformidad con lo previsto en la ley.
    </p>
    <h4 class="subtitle-2 font-italic">
      6.1. Cómo el titular puede ejercer sus derechos
    </h4>
    <p>
      Para garantizar que el usuario que pretende ejercer sus derechos es, de hecho, el titular de los datos personales objeto de la requisición, podremos solicitar documentos u otras informaciones que puedan auxiliar en su correcta identificación, a fin de resguardar nuestros derechos y los derechos de terceros. Esto solo se hará, sin embargo, si fuera absolutamente necesario, y el solicitante recibirá todas las informaciones relacionadas.
    </p>

    <h4 class="subtitle-2">
      7. Medidas de seguridad en el tratamiento de datos personales
    </h4>
    <p>
      Empleamos medidas técnicas y organizativas aptas para proteger los datos personales de accesos no autorizados y de situaciones de destrucción, pérdida, extravío o alteración de esos datos.
    </p>
    <p>
      Las medidas que utilizamos tienen en consideración la naturaleza de los datos, el contexto y la finalidad del tratamiento, los riesgos que una eventual violación generaría para los derechos y libertades del usuario, y los estándares actualmente empleados en el mercado por empresas semejantes a la nuestra.
    </p>
    <p>
      Entre las medidas de seguridad adoptadas por nosotros, destacamos las siguientes:
    </p>
    <ul>
      <li>Los datos de nuestros usuarios son almacenados en ambiente seguro</li>
      <li>Limitamos el acceso a los datos de nuestros usuarios, de modo que terceros no autorizados no puedan acceder a ellos</li>
      <li>Utilizamos certificado SSL (Secure Socket Layer), de modo que la transmisión de datos entre los dispositivos de los usuarios y nuestros servidores ocurra de forma cifrada</li>
      <li>Mantenemos registros de todos aquellos que tienen, de alguna forma, contacto con nuestros datos</li>
    </ul>
    <p>
      Aunque adoptemos todo lo que está a su alcance para evitar incidentes de seguridad, es posible que ocurra algún problema motivado exclusivamente por un tercero —como en caso de ataques de hackers o crackers o, aún, en caso de culpa exclusiva del usuario, que ocurre, por ejemplo, cuando él mismo transfiere sus datos a tercero. Así, aunque seamos, en general, responsables por los datos personales que tratamos, nos eximimos de responsabilidad en caso de que ocurra una situación excepcional como esas, sobre las cuales no tenemos ningún tipo de control.
    </p>
    <p>
      De cualquier forma, en caso de que ocurra cualquier tipo de incidente de seguridad que pueda generar riesgo o daño relevante para cualquiera de nuestros usuarios, comunicaremos a los afectados y a la Autoridad Nacional de Protección de Datos acerca de lo ocurrido, en conformidad con lo dispuesto en la Ley General de Protección de Datos.
    </p>

    <h4 class="subtitle-2">
      8. Reclamo ante una autoridad de control
    </h4>
    <p>
      Sin perjuicio de cualquier otra vía de recurso administrativo o judicial, los titulares de datos personales que se sientan, de cualquier forma, lesionados, pueden presentar reclamo a la Autoridad Nacional de Protección de Datos.
    </p>

    <h4 class="subtitle-2">
      9. Alteraciones en esta política
    </h4>
    <p>
      La presente versión de esta Política de Privacidad fue actualizada por última vez el: 29/09/2020.
    </p>
    <p>
      Nos reservamos el derecho de modificar, en cualquier momento, las presentes normas, especialmente para adaptarlas a las eventuales alteraciones realizadas en nuestra aplicación, ya sea por la disponibilización de nuevas funcionalidades, ya sea por la supresión o modificación de aquellas ya existentes.
    </p>
    <p>
      Siempre que haya una modificación, nuestros usuarios serán notificados acerca del cambio.
    </p>
    <h4 class="subtitle-2">
      10. Cómo contactarnos
    </h4>
    <p>
      Para esclarecer cualquier duda sobre esta Política de Privacidad o sobre los datos personales que tratamos, contacte a nuestro Encargado de Protección de Datos Personales por alguno de los canales mencionados a continuación:
    </p>
    <p class="indent">
      <em>Correo electrónico:</em> dpo@mobees.com.br
    </p>
    <p class="indent">
      <em>Dirección postal:</em> Ladeira da Glória, 26, Bloco III, 2º piso, sala 225, Glória, Rio de Janeiro, RJ, 22.211-120
    </p>
  </div>
</template>

<script>
  export default {
    name: 'PrivacyMobeesAR',
  }
</script>
